const slicesQuery = `
{
  baggage{
    bags {
      id
      cost {
        amount
        dollar
        priceChanged
        totalTripPrice
      }
      dimensions {
        totalSize {
          maxCms
          maxIns
        }
      }
    }
    type
    carrierCode
    numberOfBags
  }
  segment {
    arrivalDateTime
    bkgClass
    cabinClass
    cabinName
    departDateTime
    destAirport
    duration
    equipmentCode
    flightNumber
    genericSeatAssgnFlag
    id
    segmentId
    marketingAirline
    origAirport
    overnightFlight
    premiumSeatingFlag
    seatmapAvailable
    seatSelectionAllowed
    allowStandby
    allowCabinUpgrades
    allowPreferredSeating
    allowPriorityBoarding
    stopQuantity
    distance
  }
  brandAttributeMatrix
  fareBrands {
    defaultBrand
    bookingClasses
    groupId
    refId
    contentSourceId
    name
    displayName
    fareInfoList {
      fareBasisCode
    }
    ancillaries {
      tag
      name
      coreAttribute
      offerType
      displayOrderingVal
      setiDisplayOrderingVal
    }
    coreFBAncillaries {
      color
      icon
      name
      modifier
      index
    }
    description
    key
    brandTier
    airline
    fareDifference
    isFareDifferenceNegative
    isSelected
    itineraryType
    totalFare
    splitTicketFees
    sliceIds
    totalUpsellDisplayPrice {
      amount
      currency
    }
    totalFare
    fees {
      amount
      currency
    }
    tax {
      amount
      currency
    }
    fare {
      amount
      currency
    }
    pricing {
      amount
      ctaText
      text
    }
  }
  duration
  id
  airlineName
  airlineLogo
  origAirportCode
  destAirportCode
  sliceId
  willRenderContent
  selectedBrandIndex
}
`

export const airTransformedAirPriceQuery = `
query airPriceResponse($input: AirPriceRequest) {
  airPriceResponse(input: $input) {
    isFireFly
    isFused
    selectedFareBrandNames
    passportRequired
    nationalityRequired
    itineraryType
    isSeatEligible
    doAnyFareBrandsHaveSeatChoice
    processorID
    requestId
    resultCode
    ucEligible
    itineraryReference {
      groupId
      refId
      pricedConfirmationId
      refKey
      token
    }
    error {
      code
      desc
    }
    referrals {
      external {
        refId
        referralSourceId
      }
    }
    priceGuidance {
      high
      low
      isEligible
    }
    pricingInfo {
      currency
      price
      totalTripPrice
      dollar
      cents
      priceChanged
    }
    baggage {
      disclaimer
      data {
        airlineName
        airlineLogo
        baggageInfoUrl
        baggageOptions {
          type
          bags {
            name
            availability
            cost
          }
        }
      }
    }
    baggageFeeData {
      airlineCode
      airlineName
      airlineLogo
      baggageURL
      baggage {
        numberOfBags
        type
        carrierCode
        bags {
          id
          weight {
            maxLbs
          }
          dimensions {
            totalSize {
              maxIns
              maxCms
            }
          }
          cost {
            amount
            currency
          }
        }
      }
    }
    covidAttributes {
      airlineCode
      airlineLogo
      airlineName
      covidAttrs {
        noChangeFees
        mandatoryMask
        healthCert
        tempChecks
        extraCleaning
        middleSeatBlocked
        reducedOnboard
      }
    }
    seatMapObj{
      airSeatmapReq {
        requestId
        clientSessionId
        itineraryReference {
          refId
          groupId
        }
        flight {
          arrivalDateTime
          bkgClass
          cabinClass
          cabinName
          departDateTime
          destAirport
          duration
          equipmentCode
          flightNumber
          genericSeatAssgnFlag
          id
          marketingAirline
          origAirport
          overnightFlight
          premiumSeatingFlag
          seatmapAvailable
          seatSelectionAllowed
          allowStandby
          allowCabinUpgrades
          allowPreferredSeating
          allowPriorityBoarding
          stopQuantity
          distance
          sliceId
          segmentRefId
          origin {
            code
            name
            city
            state
            country
            latitude
            longitude
            isoCountryCode
            cityId
            cityGisId
            cityCode
            gmtTimeZoneOffset
          }
          destination {
            code
            name
            city
            state
            country
            latitude
            longitude
            isoCountryCode
            cityId
            cityGisId
            cityCode
            gmtTimeZoneOffset
          }
          genericSeatAssgnCost{
            amount
            currencyCode
          }
        }
      }
    }
    fareBrandsInfo{
      defaultBrandsBySliceId {
        id
        value
      }
      keysBySliceId {
        id
        value
      }
      initialSelections {
        id
        value
      }
      fareBrandsByKey {
        defaultBrand
        bookingClasses
        groupId
        refId
        contentSourceId
        name
        displayName
        description
        key
        brandTier
        airline
        fareDifference
        isFareDifferenceNegative
        isSelected
        itineraryType
        totalFare
        splitTicketFees
        fareInfoList {
          fareBasisCode
        }
        ancillaries {
          name
          offerType
          coreAttribute
          displayOrderingVal
          tag
          setiDisplayOrderingVal
        }
        coreFBAncillaries {
          color
          icon
          name
          modifier
          index
        }
        sliceIds
        totalUpsellDisplayPrice {
          amount
          currency
        }
        fees {
          amount
          currency
        }
        tax {
          amount
          currency
        }
        fare {
          amount
          currency
        }
        pricing {
          amount
          text
          ctaText
        }
      }
      upsellOptions {
        groupId
        refId
        token
        itemDetailsKey
        cartToken
        priceKey
        fareFamilyReference
        savings {
          totalStrikeThroughPrice
          totalSavings
          perPersonSavings
          perPersonStrikeThroughPrice
          savingsPercentage
        }
        totalPackagePrice {
          currency
          amount
        }
        totalUpsellDisplayPrice {
          currency
          amount
        }
        totalCostWithHotelMandatoryFees {
          currency
          amount
        }
        fees {
          amount
          currency
        }
        tax {
          amount
          currency
        }
        fare {
          amount
          currency
        }
      }
      hasOneSliceOnly
      firstSliceIdWithContent
      slices {...${slicesQuery}}
      upgradedSlices {...${slicesQuery}}
  }
    ucPostObject {
      pricing {
        totalCost
        totalCostPerTraveler
        totalPayLater
        totalPayNow
        originalCostPerTraveler
        totalSavings
        potentialSavings
        currency
        symbol
        totalTravelers
        lengthOfStay
        componentRetailPrices {
          name
          icon
          displayPricePerPerson
        }
      }
      travelEndDate
      travelStartDate
      components {
        itineraryType
        type
        searchUrl
        items {
          type
          isHackerFare
          isOpaque
          prices {
           type
            fareInfos {
              uniqueSegId
              bookingClass
              cabinClass
            }
            totalPrice {
              priceChanged
              dollar
              cents
              amount
              price
              currency
              currencyCode
              currencySymbol
              totalTripPrice
  					}
            basePrice {
              priceChanged
              dollar
              cents
              amount
              price
              currency
              currencyCode
              currencySymbol
              totalTripPrice
  					}
            totalTax {
              priceChanged
              dollar
              cents
              amount
              price
              currency
              currencyCode
              currencySymbol
              totalTripPrice
  					}
          }
          slices {
            sliceId
            id
            duration
            formattedDuration
            numStops
            nonstop
            overnight
            _metaSliceId
            segments {
              arrivalDateTime
              bkgClass
              cabinClass
              cabinName
              departDateTime
              destAirport {
                type
                value
              }
              duration
              equipmentCode
              flightNum
              genericSeatAssgnFlag
              id
              marketingAirline
              origAirport
              overnightFlight
              premiumSeatingFlag
              seatmapAvailable
              seatSelectionAllowed
              allowStandby
              allowCabinUpgrades
              allowPreferredSeating
              allowPriorityBoarding
              stopQuantity
              distance
              departTime
              arrivalTime
              _metaSegmentId
              overnight
              operatingAirline
              numStops
              originAirport {
                type
                value
              }
              destinationAirport
              genericSeatAssgnCost {
                priceChanged
                dollar
                cents
                amount
                price
                currency
                currencyCode
                currencySymbol
                totalTripPrice
              }
            }
            layoverLocations
          }
          productId
        }
        meta {
          airports
          equipment
          itineraryReference {
            groupId
            pricedConfirmationId
            refId
            refKey
            token
          }
          airlines
          numAdults
          baggageFeesUrl
          ticketType
          ticketingAirline
          numAdults
          numChildren
          numInfants
          opaque
          retail
          fareFilingType
          basicEconomy
          requiresDisinsection
          isFreeCancellation
          isHackerFare
          retailPrice {
            pricePerPerson
            displayPricePerPerson
          }
          slices {
            sliceId
            id
            duration
            formattedDuration
            numStops
            nonstop
            overnight
            _metaSliceId
            segments {
              arrivalDateTime
              bkgClass
              cabinClass
              cabinName
              departDateTime
              destAirport
              duration
              equipmentCode
              flightNumber
              genericSeatAssgnFlag
              id
              marketingAirline
              origAirport
              overnightFlight
              premiumSeatingFlag
              seatmapAvailable
              seatSelectionAllowed
              allowStandby
              allowCabinUpgrades
              allowPreferredSeating
              allowPriorityBoarding
              stopQuantity
              distance
              departTime
              arrivalTime
              _metaSegmentId
              overnight
              operatingAirline
              numStops
              originAirport
              destinationAirport
              genericSeatAssgnCost {
                priceChanged
                dollar
                cents
                amount
                price
                currency
                currencyCode
                currencySymbol
                totalTripPrice
              }
            }
            layoverLocations
          }
        }
        productId
        flightSelected
      }
      origin {
        id
        type
        isoCountryCode
        displayName
        name
      }
      destination {
        id
        type
        isoCountryCode
        displayName
        name
      }
      travelers {
        adults
        children {
          age
          lapChild
        }
      }
      sourceUrl
      selectedFareBrands {
        defaultBrand
        bookingClasses
        groupId
        refId
        contentSourceId
        token
        name
        description
        key
        brandTier
        sliceIds
        totalUpsellDisplayPrice {
          amount
          currency
        }
        fees {
          amount
          currency
        }
        tax {
          amount
          currency
        }
        fare {
          amount
          currency
        }
        fareInfoList {
          fareBasisCode
        }
        ancillaries {
          name
          offerType
          coreAttribute
          displayOrderingVal
          tag
        }
      }
    }
    aaSpecificInfo {
      hasAmerican
      sliceInfo {
        bookingClass
        marketingAirline
        sliceId
      }
    }
    pricingInfo {
      amount
      priceChanged
      totalTripPrice
      dollar
      cents
    }
    itineraryReference {
      groupId
      pricedConfirmationId
      refId
    }
    baggageFeeData {
      airlineCode
      airlineLogo
      airlineName
      baggageURL
      baggage {
        bags {
          id
          cost {
            amount
            currency
          }
        }
      }
    }
    baggageFeeDataByFareBrand {
      airlineCode
      airlineName
      airlineLogo
      baggageURL
      fareBrandKey
      baggage {
        numberOfBags
        type
        carrierCode
        bags {
          id
          weight {
            maxLbs
          }
          dimensions {
            totalSize {
              maxIns
              maxCms
            }
          }
          cost {
            amount
            currency
          }
        }
      }
    }
    gordianParams{
      flightString
      isGordianEligible
      isCodeShare
      hasAACodeShare
      airGordianParams {
        fareBasis
        fareClasses
        fareFamilies
        name
      }
      hasSameFareBrands
      secondaryGordianParams {
        fareBasis
        fareClasses
        fareFamilies
      }
    }
  }
}
`
